import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap } from '@angular/router';
import * as moment from 'moment';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { BillerDashboardService } from '../../biller-dashboard.service';
import * as global from '../../../global';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { DatePipe } from '@angular/common';
import { DialogConfirmationComponent } from 'src/app/includes/census-patient-list/dialog-confirmation/dialog-confirmation.component';

interface CodeIndex {
  _id: string;
  code: string;
  description: string;
}
@Component({
  selector: 'app-charges-popup',
  templateUrl: './charges-popup.component.html',
  styleUrls: ['./charges-popup.component.css']
})
export class ChargesPopupComponent implements OnInit {
  patientData: any;
  codes: any;
  allCodes: any = {};
  companyNotesStatus: Boolean = false;
  submitCharge: BehaviorSubject<boolean> = new BehaviorSubject(false);
  chargesArray: any = []
  currentIndex: any;
  disableSubmit: Boolean = false;
  chargeSubmitted: Boolean = false;
  company_id: any;
  global = global;
  signedNotesStatus: boolean = false;
  currentUser: any;
  

  constructor(
    public billerDashboardService: BillerDashboardService,
    private _route: ActivatedRoute,
    public _authService: AuthService,
    private _toastr: ToastrService,
    private _company: CompanyService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private dialog: MatDialog,
    // @Inject(MAT_DIALOG_DATA) public arrayOfcharges: any,
  ) {
    if (this.data.route) {
      if (window.location.href.includes('biller-charges')) {
        this.company_id = this._authService.currentUser.company_id;
      }
      else {
        this.company_id = this.data.route.parent.parent.snapshot.params.id;
      }

    }
    this.currentUser = this._authService.currentUser;
  }

  async ngOnInit() {
    this.signedNotesStatus = await this._company.checkCompanyPermission("should_sign_note", this.currentUser.company_id);
    this.patientData = this.data.patient;
    if(!this.patientData?.patient_id){
      this._toastr.error("Patient Id does'nt exist.");
      // return;
    } 
    this.companyNotesStatus = this.data.companyNoteStatus;
    console.log('this.companyNotesStatus',this.data, this.companyNotesStatus);
    if(this.signedNotesStatus) {
      if(this.data.patient.note_id.is_signed == 'true') {
        this.signedNotesStatus = false;
      }
      else {
        this.signedNotesStatus = true;
      }
    }
    this.chargesArray = this.data.arrayOfcharges;
    this.currentIndex = this.chargesArray.findIndex(charge => charge._id == this.patientData._id);
    if(this.patientData?.cpt_id.length == 0 || this.patientData?.icd_id.length == 0){
      this.disableSubmit = true;
    }
  }
  async submitButtonClicked() {
    const date_obj = this.commonService.dateObjToDate(this.patientData.date_obj)
    if (moment(date_obj).isSameOrAfter(moment().add(1, 'days'))) {
      this._toastr.error("Charge cannot be submiited in future date of service", "Error");
      return;
    }
    if (this.checkToSumbitCharge()) {
      this.disableSubmit = true;
      let chargeId = "";
      let resubmitted_by = this._authService.currentUser._id;
      if (this.patientData) {
        chargeId = this.patientData._id;
      }
      else {
        chargeId = this.chargesArray[this.currentIndex]._id;
      }
      let ch = this.chargesArray.find(a=> {
        if(a._id == chargeId){
          return a
        }
      })
      // console.log("Selected Charge=== ", ch);
      let status = 'resubmit'
      if(ch && ch.status == 'draft'){
        status = 'submit'
      }
      // let status = ch.status
      let isMultipleCharges = false, canSubmitChargeWithMupltipleCpts = false, response: any;
      [canSubmitChargeWithMupltipleCpts] = await this._company.checkCompanyPermission(["allow_multiple_cpts"], this.currentUser.company_id);

      if (ch.cpt_id && ch.cpt_id.length > 1 && !canSubmitChargeWithMupltipleCpts)
        isMultipleCharges = true;

      if (isMultipleCharges){
      let dialogRef = this.dialog.open(DialogConfirmationComponent, {
        data: {
          message: 'You have selected more than one CPT <br> Are you sure to submit?'
        }
      });
      dialogRef.afterClosed().subscribe(async result => {
        if (result === 'true') {
          response = await lastValueFrom (this.billerDashboardService.submitAndApproveCharge(chargeId, status, resubmitted_by));
          if (response.status == 200)
            this._toastr.success("Charge successfully submitted");
        }
        else if (result === 'false') {
          dialogRef.close();
        }
      })
    }
      else {
        response = await lastValueFrom(this.billerDashboardService.submitAndApproveCharge(chargeId, status, resubmitted_by));
      }
      // this.billerDashboardService.submitAndApproveCharge(chargeId, status, resubmitted_by).subscribe(async (response: any) => {
      if (response && response.status == 200) {
        this._toastr.success("Charge successfully submitted");
        if (this.data.adminSide) {
          if (this.currentIndex + 1 < this.chargesArray.length) {
            this.currentIndex = this.currentIndex + 1
            // this.patientData = this.chargesArray[this.currentIndex]
            // this.disableSubmit = false;
            let res: any = await lastValueFrom(this.billerDashboardService.getPatientsChargesAdmin(null, null, this.company_id, {}, this.chargesArray[this.currentIndex]._id));
            this.patientData = res.data[0];
            this.disableSubmit = false;
            this.chargeSubmitted = true;
          }

        }
        else {
          this.chargeSubmitted = true;
          this.submitCharge.next(true)
          if (this.currentIndex + 1 < this.chargesArray.length) {
            this.currentIndex = this.currentIndex + 1
            this.patientData = this.chargesArray[this.currentIndex]
            this.disableSubmit = false;
          }
        }
      }
          // })
    }
  }
  async prevButtonClicked() {
    this.disableSubmit = false;
    if (this.currentIndex > 0) {
      this.currentIndex = this.currentIndex - 1;
      if (this.data.adminSide) {
        this.disableSubmit = true;
        let res: any = await this.billerDashboardService.getPatientsChargesAdmin(null, null, this.company_id, {}, this.chargesArray[this.currentIndex]._id).toPromise()
        this.patientData = res.data[0];
        if(this.patientData?.cpt_id.length == 0 || this.patientData?.icd_id.length == 0){
          this.disableSubmit = true;
        }else{
          this.disableSubmit = false;
        }        
      }
      else {
        this.patientData = this.chargesArray[this.currentIndex];
        if(this.patientData?.cpt_id.length == 0 || this.patientData?.icd_id.length == 0){
          this.disableSubmit = true;
        }
      }
    }
  }
  async nextButtonClicked() {
    this.disableSubmit = false;
    if (this.currentIndex + 1 < this.chargesArray.length) {
      this.currentIndex = this.currentIndex + 1;
      if (this.data.adminSide) {
        this.disableSubmit = true;
        let res: any = await this.billerDashboardService.getPatientsChargesAdmin(null, null, this.company_id, {}, this.chargesArray[this.currentIndex]._id).toPromise()
        this.patientData = res.data[0];
        if(this.patientData?.cpt_id.length == 0 || this.patientData?.icd_id.length == 0){
          this.disableSubmit = true;
        }else{
          this.disableSubmit = false;
        }
      }
      else {
        this.patientData = this.chargesArray[this.currentIndex];
        if(this.patientData?.cpt_id.length == 0 || this.patientData?.icd_id.length == 0){
          this.disableSubmit = true;
        }
      }
    }
  }
  checkToSumbitCharge() {
    if (this.patientData.note_id) {
      if (this.companyNotesStatus) {
        if (this.patientData.note_id.is_signed === "true") {
          return true;
        } else {
          this._toastr.info("Note must be signed first before submitting the charges");
          return false;
        }
      } else {
        return true;
      }
    } else {
      if (this.companyNotesStatus) {
        this._toastr.info("Note must be created first before submitting the charges");
        return false;
      } else {
        return true;
      }
    }
  }

  getpatientInfo() {
    let patient = this.patientData
    let patientInfo = patient.patient_id.first_name + " " + patient.patient_id.last_name
    if (patient.patient_id.date_of_birth) {
      let formattedDate = this.datePipe.transform(patient.patient_id.date_of_birth, 'MM/dd/yyyy');
      patientInfo = patientInfo + "  (" + formattedDate + ")";
    }
    if (patient?.patient_id.gender.toLowerCase() == 'male') {
      patientInfo = patientInfo + " - M";
    }
    else {
      patientInfo = patientInfo + " - F";
    }
    return patientInfo;
  }

  getCodesLength() {
    let record = this.patientData;
    let icdCode = record.icd_id.length;
    let cptCode = record.cpt_id.length;

    if (icdCode >= cptCode) {
      this.codes = record.icd_id;
      this.allCodes.cpt = record.cpt_id;
      this.allCodes.icd = record.icd_id;
    }
    else {
      this.codes = record.cpt_id;
      this.allCodes.cpt = record.cpt_id;
      this.allCodes.icd = record.icd_id;
    }
    return this.codes;
  }

  getVisitDate(codeIndex) {
    let element = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (index == 0) { 
      let date = element.visit_date
      if (element) {
        if(element.date_obj){
          // console.log("element.date_obj: ", element.date_obj);
          let {year, month, day, hour, minute} = element.date_obj;
          if(month < 10){
              month = '0' + month;
          }
          if(day < 10){
              day = '0' + day;
          }
          let str = `${month}/${day}/${year}`; 
          return str
        }
        else{
          let timeZone = 'America/New_York'
          if(element.facility_id_ref.pcc_timeZone){
            timeZone = element.facility_id_ref.pcc_timeZone
          }
          else if (element.facility_id_ref.timeZone){
            timeZone = element.facility_id_ref.timeZone
          }
          return moment(new Date(element.visit_date).toLocaleString('en-US', { timeZone: timeZone })).format('MM/DD/YYYY')
        }
        // return moment(new Date(date).toLocaleString('en-US', { timeZone:  'America/Los_Angeles' })).format('MMM DD, YYYY h:mm a')
        // return moment(new Date(date)).format('MMM DD, YYYY h:mm a')
      }
      else {
        return '';
      }
    }
    else {
      return '';
    }
  }

  getProvider(codeIndex) {
    let record = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (index == 0) {
      return record.owner_id.first_name + " " + record.owner_id.last_name
    }
    else {
      return '';
    }
  }

  getICD(codeIndex) {
    let record = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (record.icd_id[index] && record.icd_id[index]?.code) {
      return record.icd_id[index].code
    }
    else {
      return '-';
    }
  }
  getCPT(codeIndex) {
    let record = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (record.cpt_id[index]) {
      return record.cpt_id[index].code
    }
    else {
      return '';
    }
  }

  getCPTID(codeIndex: CodeIndex): string {
    const index = this.codes.findIndex(element => element.code === codeIndex["code"]);
    return (index !== -1 && this.patientData.cpt_id[index]) ? this.patientData.cpt_id[index]._id : "null";
  }

  getPOS(codeIndex: CodeIndex): string {
    const facilityPOS = this.patientData?.facility_id_ref?.pos_id?.code || "";
    const cptID = this.getCPTID(codeIndex);

    if (cptID === "null") return "";

    const pos = this.patientData.cpt_pos.find(element => element.cpt_id === cptID)?.pos;
    return pos || facilityPOS;
  }
  getICDName(codeIndex) {
    let record = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (record.icd_id[index] && record.icd_id[index]?.description) {
      return record.icd_id[index].description
    }
    else {
      return '';
    }
  }
  getCPTName(codeIndex) {
    let record = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (record.cpt_id[index]) {
      return record.cpt_id[index].description
    }
    else {
      return '';
    }
  }
  checkVoidCensus(){
    if(this.patientData?.rounding_sheet_id?.is_void){
      if(this.patientData?.rounding_sheet_id.is_void === true) return false;
      else return true;
    }else{
      return true
    }
  }
  getAddress(codeIndex) {
    let patient = this.patientData;
    let index = this.codes.findIndex(element => element.code == codeIndex.code);
    if (index == 0) {
      if (patient && patient.facility_id_ref && patient.facility_id_ref.title) {
        return patient.facility_id_ref.title;
      }
      else {
        return '';
      }
    }
  }

}
